import { safeFetch } from "../utils/safeFetch";

const throwApiError = async (response, fallbackMessage) => {
    if (response.status === 0) {
        throw new Error(fallbackMessage);
    }

    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || error.message || `HTTP error! status: ${response.status}`);
};

const normalizeReservationPayload = (payload = {}) => {
    const packagesFromPayload = Array.isArray(payload.packageIds)
        ? payload.packageIds
        : Array.isArray(payload.packages)
            ? payload.packages
            : [];

    const packageIds = packagesFromPayload
        .map((pkg) => {
            if (typeof pkg === 'number') return pkg;
            if (pkg && typeof pkg === 'object') {
                if (typeof pkg.packageId === 'number') return pkg.packageId;
                if (typeof pkg.id === 'number') return pkg.id;
            }
            return null;
        })
        .filter((id) => Number.isInteger(id) && id > 0);

    const nextPayload = { ...payload };
    if (packageIds.length > 0) {
        // Keep both keys temporarily for backward/forward compatibility.
        nextPayload.packageIds = packageIds;
        nextPayload.packages = packageIds;
    }

    return nextPayload;
};

export const getAllPrenotazioni = async (token, tenant, options = {}) => {
  const noCache = Boolean(options?.noCache);
  const url = noCache ? `/api/reservations?ts=${Date.now()}` : `/api/reservations`;
  const response = await safeFetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  }, noCache ? null : "allReservations");

  if (!response.ok) {
    await throwApiError(response, "Impossibile connettersi al server o recuperare dati offline.");
  }

  return await response.json();
};

export const creaPrenotazione = async (prenotazione, token, tenant) => {
    const normalizedPrenotazione = normalizeReservationPayload(prenotazione);
    const response = await safeFetch(`/api/reservations`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            'x-tenant-id': tenant,
        },
        body: JSON.stringify(normalizedPrenotazione),
    });

  if (!response.ok) {
    await throwApiError(response, "Impossibile connettersi al server");
  }

  return await response.json();
};

export const aggiornaPrenotazione = async (reservationId, updatedData, token, tenant) => {
    const normalizedUpdatedData = normalizeReservationPayload(updatedData);
    const response = await safeFetch(`/api/reservations/${reservationId}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            'x-tenant-id': tenant,
        },
        body: JSON.stringify(normalizedUpdatedData),
    });

  if (!response.ok) {
    await throwApiError(response, "Impossibile connettersi al server");
  }

  return await response.json();
};

export const aggiornaStatoPrenotazione = async (reservationId, status, token, tenant, cancellationReason) => {
  const payload = { status };
  if (typeof cancellationReason === "string") {
    payload.cancellationReason = cancellationReason;
  }

  const response = await safeFetch(`/api/reservations/${reservationId}/status`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    await throwApiError(response, "Impossibile connettersi al server");
  }

  return await response.json();
};

export const eliminaPrenotazione = async (reservationId, token, tenant) => {
  const response = await safeFetch(`/api/reservations/${reservationId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  });

  if (!response.ok) {
    await throwApiError(response, "Impossibile connettersi al server");
  }

  // 204 No Content — no body to parse
  if (response.status === 204) return null;
  return await response.json();
};
